const { host } = window.location;

const protocol = 'https';

const serviceType = {
  api: '',
};
// Production builds keep the default. The staging build sets REACT_APP_API_HOST
// at compile time so that it never calls the production API.
const hostApi = process.env.REACT_APP_API_HOST || 'api.lunch.team';

const currentHost = () => {
  return `${protocol}://${host}`;
};

const currentServerHost = () => {
  return `${protocol}://${hostApi}`;
};

function server(service, path = '') {
  return `${currentServerHost()}${service}${path}`;
}

export default {
  api: path => server(serviceType.api, path),
  currentHost: currentHost,
};



// WEBPACK FOOTER //
// ./src/config/fetch/serverURL.js